import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var Overlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),\n    url(", "); */\n  background-image: url(", ");\n  background-size: cover;\n  opacity: ", ";\n  height: ", ";\n  display: flex;\n  gap: 0.5rem;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-content: baseline;\n  padding: 1rem;\n"], ["\n  /* background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),\n    url(", "); */\n  background-image: url(", ");\n  background-size: cover;\n  opacity: ", ";\n  height: ", ";\n  display: flex;\n  gap: 0.5rem;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-content: baseline;\n  padding: 1rem;\n"])), function (_a) {
    var $backgroundImage = _a.$backgroundImage;
    return $backgroundImage;
}, function (_a) {
    var _b = _a.$backgroundImage, $backgroundImage = _b === void 0 ? "" : _b;
    return $backgroundImage;
}, function (_a) {
    var _b = _a.$opacity, $opacity = _b === void 0 ? "1" : _b;
    return $opacity;
}, function (_a) {
    var _b = _a.$height, $height = _b === void 0 ? "100%" : _b;
    return $height;
});
var templateObject_1;
